import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { format } from 'date-fns';

export interface WhatsappState {
  month: string;
}

const initialState: WhatsappState = {
  month: format(new Date(), 'yyyy-MM'),
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setMonth: (state, action: PayloadAction<string>) => {
      state.month = action.payload;
    },
  },
});

export const { setMonth } = dashboardSlice.actions;

export default dashboardSlice.reducer;
